import { z, isoZ } from 'my-zod'
import {
  DamageWaiverCaseHazardCategoryTypeEnum,
  DamageWaiverCaseLifecycleStatusEnum,
  DamageWaiverCaseRespondingAuthoritiesTypeEnum,
  DamageWaiverCaseSeverityTypeEnum
} from './damage-waiver-case-enums'
import { repairInfoFragment } from './repair-info-fragment'
import { advancedReviewInfoFragment } from './advanced-review-info-fragment'
import { productLineOptions } from '../../internal'
import { attachmentModel } from '../../utilities/attachment'
import { TeamsEnum } from '../../utilities/user/teams-enum'

export const damageWaiverCaseModel = z.object({
  shortId: z.string(),
  outfitterId: z.number().min(1, 'Required').setLabel('Outfitter Name'),
  assignedUserId: z.number().min(1, 'Required').setLabel('Assigned To'),
  assignedTeam: TeamsEnum,
  riskSpecialistId: z.number().min(1, 'Required').setLabel('Risk Specialist'),
  createdUserId: z.number().min(1, 'Required').setLabel('Created By'),
  subject: z.string().nonempty().setLabel('Subject'),
  notes: z.string(),
  lifecycleStatus: DamageWaiverCaseLifecycleStatusEnum,
  vehicleId: z.number().min(1, 'Required'),
  reopenReason: z.string().min(1).max(100).nullable().setLabel('Re-open Reason'),
  closingReason: z.string().min(1).max(100).nullable(),
  customerWaiverIds: z.string().uuid().array(),
  repairInfo: repairInfoFragment,
  advancedReviewInfo: advancedReviewInfoFragment.nullable(),

  // incident and vehicle
  productLine: z.enum(productLineOptions),
  severity: DamageWaiverCaseSeverityTypeEnum,
  hazardCategory: DamageWaiverCaseHazardCategoryTypeEnum.nullable(),
  incidentDate: isoZ.date(),
  incidentTime: isoZ.time(),
  respondingAuthorities: DamageWaiverCaseRespondingAuthoritiesTypeEnum.array(),
  vehicleMiles: z.number().nullable(),
  vehicleEngineHours: z.number().nullable(),
  isAnyProperyDamaged: z.boolean().setLabel('Was any property damaged ?'),
  vehicleDamageDescription: z.string(),
  incidentAndPropertyDamageDescription: z.string(),
  safetyVisibility: z.boolean(),
  // end incident and vehicle
  attachments: attachmentModel.array(),
  lastModifiedByUserId: z.number().setLabel('Last Modified By'),
  completionDate: isoZ.instant().nullable().setLabel('Closed Date'),
  createdDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable(),
  lastModifiedDate: isoZ.instant()
})

export type damageWaiverCaseModel = z.infer<typeof damageWaiverCaseModel>
